export * from './common-properties-options'
export * from './currency'
export * from './custom-variable'
export * from './elements'
export * from './groups'
export * from './productLineItems'
export * from './rrule'
export * from './schedule-options'
export * from './styles'

export const DEFAULT_PAGE_DIMENSION = {
  dimensions: { width: 816, height: 1056 },
  margins: { top: 48, right: 48, bottom: 48, left: 48 },
}

export const OLD_PAGE_HEIGHT = 1152
export const OLD_PAGE_WIDTH = 816
export const OLD_PAGE_MARGIN = 48

// Maximum number of distinct roles that can be assigned to fillable fields in a single template.
// More roles can be defined, but only up to this many may be assigned to fields.
export const MAX_ASSIGNED_ROLES = 6

export const TEMPLATE_LIBRARY_INTERNAL_AGENCY_ID = [
  'Xc3YnOTZmyvB7D1YWo4T', // staging
  'pfpm9iFi4k5yvjnstXWU', // production
  'R2pWHmpWmAidzVtzQjUy', // AU production
]

export const CONTENT_LIBRARY_INTERNAL_AGENCY_ID = [
  '5DP4iH6HLkQsiKESj6rh', // staging
  'Xc3YnOTZmyvB7D1YWo4T', // staging
  'pfpm9iFi4k5yvjnstXWU', // production
  'hfNhl3Ds0WNsDFLjtdPo', // AU internal agency (same as REGION_INTERNAL_COMPANY_IDS.au)
  'pGcN3H2ZrCUcUV0nCZfp', // AU internal agency (same as REGION_INTERNAL_COMPANY_IDS.au)
  'QIKIEY2ow3Yoiz9IIFY6', // AU agency that owns the featured content library location (LoVsQje6KP9D93il4w7R)
  'R2pWHmpWmAidzVtzQjUy', // AU production agency that owns the featured content library location (X2yrH4nZXWtDx8S5KdPI)
]

export const INTERNAL_AGENCY_IDS = [
  '5DP4iH6HLkQsiKESj6rh',
  'YuTUZlUtrwBtvmgByZDW',
  'ktapXmiRvMM4pJHyN3b3',
  'pfpm9iFi4k5yvjnstXWU',
  'R2pWHmpWmAidzVtzQjUy',
] // R2pWHmpWmAidzVtzQjUy (AU production) & 5DP4iH6HLkQsiKESj6rh (staging) & YuTUZlUtrwBtvmgByZDW (production) & ktapXmiRvMM4pJHyN3b3(production) & pfpm9iFi4k5yvjnstXWU(production)
